import { useRef } from 'react'
import { Text } from '@mantine/core'
import PositionCard from './PositionCard'
import useColumnCount from '../lib/useColumnCount'

// #1080 案件一覧。propsをそのまま描画するだけ（データ計算はRails側）。
// 列数はグリッド自身の実測幅から決める(lib/useColumnCount)。
export default function PositionList({ positions = [] }) {
  const ref = useRef(null)
  const cols = useColumnCount(ref)

  if (positions.length === 0) {
    return <Text c="dimmed" py="xl" ta="center">該当する案件が見つかりませんでした。</Text>
  }

  return (
    <div
      ref={ref}
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${cols}, 1fr)`,
        gap: 'var(--mantine-spacing-md)',
      }}
    >
      {positions.map((position) => (
        <PositionCard key={position.id} position={position} />
      ))}
    </div>
  )
}
